module.exports = __webpack_public_path__ + "static/media/icon-banner-white.07798af8.svg";